import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Navbar = (props) => {
	const { handleOpen, stateMobileNavbar, setStateMobileNavbar, temp } = props;
	const { t } = useTranslation("common");
	const isTourist = useSelector((state) =>
		Boolean(state?.BalanceReducer?.payloadAfterLogIn?.isTourist),
	);

	const closeMobileNavbar = () => setStateMobileNavbar("navbar-container");
	const isMobileNavbarOpen = stateMobileNavbar?.includes("active");

	return (
		<Fragment>
			<div className={stateMobileNavbar}>
				<a className="closeMobile" onClick={closeMobileNavbar}>
					<i className="symmetry-icon-cancel"></i>
				</a>
				<nav className="navbar">
					<NavLink
						onClick={closeMobileNavbar}
						exact
						to="/"
						activeclassname="active"
						className="navbar-item"
					>
						<svg
							width="18"
							height="19"
							viewBox="0 0 18 19"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M7.59415 0.577476C8.37324 -0.192492 9.62676 -0.192492 10.4059 0.577476L17.1088 7.20185C17.6791 7.76544 18 8.53386 18 9.33564V17.0003C18 18.1049 17.1046 19.0003 16 19.0003H13C11.8954 19.0003 11 18.1049 11 17.0003V12.0003H7V17.0003C7 18.1049 6.10457 19.0003 5 19.0003H2C0.89543 19.0003 0 18.1049 0 17.0003V9.33564C0 8.53386 0.320945 7.76544 0.891219 7.20185L7.59415 0.577476ZM9 2L2.29707 8.62438C2.10698 8.81224 2 9.06838 2 9.33564V17.0003H5V12.0003C5 10.8957 5.89543 10.0003 7 10.0003H11C12.1046 10.0003 13 10.8957 13 12.0003V17.0003H16V9.33564C16 9.06838 15.893 8.81224 15.7029 8.62438L9 2Z"
								fill="currentColor"
							/>
						</svg>
						<span className="hideOnTablet">
							{t(isTourist ? "myIOTGTourist" : "myIOTG")}
						</span>
					</NavLink>
					<NavLink
						onClick={closeMobileNavbar}
						to="/packages"
						activeclassname="active"
						className="navbar-item"
					>
						{t("packages")}
					</NavLink>
					{!isTourist ? (
						<a
							onClick={() => {
								closeMobileNavbar();
								handleOpen();
							}}
							activeclassname="active"
							className="navbar-item"
						>
							{t("renewal")}
						</a>
					) : null}
					<NavLink
						onClick={closeMobileNavbar}
						to="/sms-language"
						activeclassname="active"
						className="navbar-item"
					>
						{t("sms-lang")}
					</NavLink>
					{isMobileNavbarOpen ? (
						<div style={{ position: "relative", right: "-13px", top: "6px" }}>
							{temp}
						</div>
					) : null}
				</nav>
			</div>
			<div className="gradient-line"></div>
		</Fragment>
	);
};

export default Navbar;
